import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { SemControlComponent } from '../sem-control/sem-control.component';

interface SemProgressBarStep {
    Key: string;
    Label: string;
}

@Component({
    selector: 'sem-progress-bar',
    templateUrl: './sem-progress-bar.component.html',
    styleUrls: ['./sem-progress-bar.component.css'],
    standalone: false
})
export class SemProgressBarComponent extends SemControlComponent implements OnInit, AfterContentInit {

    @Input() binding: string = null;
    @Input() stepsJson: string = null;

    steps: SemProgressBarStep[] = [];

    ngAfterContentInit() {
        this.parseSteps();
    }

    ngOnInit() {
    }

    private parseSteps() {
        if (this.stepsJson) {
            try {
                this.steps = JSON.parse(this.stepsJson) || [];
            } catch (e) {
                this.steps = [];
            }
        }
    }

    // Computed fresh on every Angular change-detection run instead of cached off a specific event -
    // modelValueChanged only fires on form load/refresh, not on every field edit, so caching it would
    // leave the bar stale while the user is still editing the bound field (e.g. the Status dropdown,
    // now a real nested SemDropDownSelectControl child - see reference_form_control_generated_from_model)
    // before saving. Reading straight from the model here reacts immediately to any edit.
    get currentIndex(): number {
        if (!this.binding || !this.model) {
            return -1;
        }

        let value = this.dfms.getValue(this.model, this.binding);

        // Registry/reference properties come through as an object (e.g. { Title: "Osnutek", Id: 7 });
        // plain string-bound properties come through as-is.
        let key = (value != null && typeof value === 'object') ? value.Title : value;

        return this.steps.findIndex(s => s.Key === key);
    }

    stepState(index: number): string {
        const current = this.currentIndex;
        if (current < 0) {
            return 'pending';
        }
        if (index < current) {
            return 'done';
        }
        if (index === current) {
            return 'current';
        }
        return 'pending';
    }

    stepLabel(step: SemProgressBarStep): string {
        return this.translationsService.translate(step.Label);
    }

}
